import { render, staticRenderFns } from "./AttributesInfoModal.vue?vue&type=template&id=10c3e08a&scoped=true&"
import script from "./AttributesInfoModal.vue?vue&type=script&lang=js&"
export * from "./AttributesInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c3e08a",
  null
  
)

export default component.exports